module.exports = __webpack_public_path__ + "img/Vivienda-Incendio.3b0f13c9.png";